var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.0909 15.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.23347 14.2453C6.58274 13.5543 4.41236 12.9906 4.40939 12.9906C4.40346 12.9876 4.4005 11.1328 4.4005 8.86583V4.74409L4.21667 4.88351C4.00022 5.04413 3.72151 5.19264 3.46059 5.28356C2.99212 5.44721 2.33685 5.45024 1.85059 5.29265C0.972943 5.00473 0.30878 4.29252 0.0656491 3.38029C0.00931386 3.16208 -0.00254619 3.05297 0.000418825 2.68323C0.00338384 2.29833 0.0122789 2.21044 0.0834392 1.97708C0.36808 1.01332 1.04707 0.334446 1.98401 0.0738072C2.31016 -0.0171134 2.92096 -0.0262055 3.24414 0.0586537C4.05359 0.270802 4.72368 0.831479 5.05576 1.57703C5.10024 1.6831 5.1714 1.86797 5.20698 1.99223L5.27517 2.21347L5.28407 5.75937C5.28703 7.7081 5.30186 9.31437 5.31372 9.32649C5.32854 9.34164 13.1532 11.3813 13.1977 11.3813C13.2036 11.3813 13.2066 10.3781 13.2066 9.15374V6.92619L13.0554 7.04741C12.836 7.22623 12.575 7.36564 12.2696 7.46868C10.8761 7.94753 9.38765 7.1747 8.91028 5.72301C8.7472 5.229 8.7472 4.56225 8.91028 4.07128C9.22457 3.11358 10.0073 2.40744 10.9532 2.22862C11.2141 2.1771 11.7211 2.18316 11.9761 2.23772C12.9575 2.44986 13.7344 3.20147 14.0131 4.21372L14.0813 4.45618L14.0902 9.98112C14.0931 13.0179 14.0872 15.503 14.0753 15.5C14.0605 15.497 11.8842 14.9333 9.23347 14.2453Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.2e21bb60989259452e15e09d8e598767.svg";
export { ForwardRef as ReactComponent };